import React from 'react';

import BlankCard from '~components/atoms/BlankCard';
import CustomSkeleton from '~components/atoms/Skeleton';

import * as Styles from './salesReportCardsSummary.module.scss';

import { useAppSelector } from '~redux/hooks';

import UtilFunctions from '~utils/functions';

type SalesReportCardsSummaryProps = {
    totalSales: number;
    totalTransactions: number;
    totalAffinSplit: number;
    totalTttSplit: number;
};

const SalesReportCardsSummary = ({ totalSales, totalTransactions, totalAffinSplit, totalTttSplit }: SalesReportCardsSummaryProps) => {
    const {
        Misc: {
            dateFormat,
        },
    } = UtilFunctions;

    const filters = useAppSelector(state => state.report.salesReport.salesReportTransactionListing.appliedFilters);
    const loading = useAppSelector(state => state.report.loadings.getSalesReportCardSummary);

    const renderDate = () => (
        loading
            ? <CustomSkeleton height={20} width={150} />
            : `${dateFormat(filters.dateFrom)} to ${dateFormat(filters.dateTo)}`
    );

    const renderValue = (value: string | number) => (
        loading
            ? <CustomSkeleton height={30} />
            : value
    );

    return (
        <div className={Styles.container}>
            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL SALES</p>
                    <span>{renderDate()}</span>
                    <h3>{renderValue(`RM${totalSales}`)}</h3>
                </div>
            </BlankCard>

            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL TRANSACTIONS</p>
                    <span>{renderDate()}</span> 
                    <h3>{renderValue(totalTransactions)}</h3>
                </div>
            </BlankCard>

            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL AFFIN SPLIT</p>
                    <span>{renderDate()}</span> 
                    <h3>{renderValue(`RM${totalAffinSplit}`)}</h3>
                </div>
            </BlankCard>

            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL TTT SPLIT</p>
                    <span>{renderDate()}</span>
                    <h3>{renderValue(`RM${totalTttSplit}`)}</h3>
                </div>
            </BlankCard>
        </div>
    );
};

export default SalesReportCardsSummary;
